import React from 'react';
import { Navigate } from 'react-router';

import { Loadable } from '../../../components/navigation/Loadable';
import { allowedUserType, USER_TYPES } from '../../../utils/constants';
import { baseFormsRoutes } from './baseFormsRoutes';
import { withPrivateRoute } from '../withPrivateRoute';

const { PATIENT } = USER_TYPES;

/**
 * @satisfies {ExtendedRouteObject}
 */
const baseConsultRoutes = {
  name: 'Consults',
  path: '/consults',
  type: 'layout',
  ...withPrivateRoute(undefined, {
    userCanAccess: ({ userType }) => allowedUserType([PATIENT], userType),
  }),
  children: [
    {
      name: 'Consults',
      index: true,
      path: '',
      type: 'item',
      ...withPrivateRoute(
        Loadable(React.lazy(() => import('../../../components/dashboard/consults/consults-container'))),
        {
          userCanAccess: ({ userType }) => allowedUserType([PATIENT], userType),
        },
      ),
    },
    ...baseFormsRoutes,
    {
      name: 'Checkup Form',
      path: 'checkup-form',
      type: 'item',
      element: Loadable(React.lazy(() => import('../../../components/form/other-forms/checkup-form'))),
    },
  ],
};

/**
 * @satisfies {ExtendedRouteObject[]}
 */
const consultRedirects = [
  {
    name: 'Checkup Form Redirect',
    path: 'checkup-form',
    type: 'item',
    element: <Navigate to="/consults/checkup-form" replace />,
  },
];

/**
 * @satisfies {{
 *   baseConsultRoutes: ExtendedRouteObject,
 *   consultRedirects: ExtendedRouteObject[],
 * }}
 */
export const consultRoutes = { baseConsultRoutes, consultRedirects };
